import { fetchWebQrLogin } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { Platform } from 'react-native'
import keys from './shared/keys'

export const EXPIRATION_SECONDS = 30

export function useWebQRLogin(deviceToken?: string) {
  const { server } = useServer()

  return useQuery({
    queryKey: [...keys.qrLoginStatus, deviceToken],
    queryFn: fetch,
    enabled: Platform.OS === 'web' && !!deviceToken,
    refetchInterval: query =>
      query.state.data?.authenticated ? false : 2 * 1000,
    gcTime: 1,
  })

  async function fetch() {
    if (!deviceToken) {
      return { authenticated: false }
    }

    const response = await fetchWebQrLogin(server, deviceToken)
    if (response.authenticated) {
      const restored =
        (await server.restoreSession?.()) ?? response.authenticated
      return { authenticated: restored }
    }
    return response
  }
}
